import { render } from "./LeftSidebarProjects.vue?vue&type=template&id=6e06ed3a&scoped=true"
import script from "./LeftSidebarProjects.vue?vue&type=script&lang=js"
export * from "./LeftSidebarProjects.vue?vue&type=script&lang=js"

import "./LeftSidebarProjects.vue?vue&type=style&index=0&id=6e06ed3a&scoped=true&lang=scss"

import exportComponent from "D:\\tachyon\\Projects\\NowMedia\\tool_cases\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e06ed3a"]])

export default __exports__